import Routes from "./Routes";
import LRC from "./LRC/Routes";
import MO from "./MoveOrder/Routes";
import PlanLeave from "./PlanLeave";
import ReportLeave from "./Reports/Routes";
import LeaveRestriction from "./LeaveRestriction/Routes";
import Settings from "./Settings";
import OutPass from "./OutPass/Routes";
import SickReports from "./SickReports/Routes";

export default [...MO, ...LRC, ...Routes, ...OutPass, ...Settings, ...PlanLeave, ...ReportLeave, ...LeaveRestriction, ...SickReports];
